// extracted by mini-css-extract-plugin
module.exports = {"subscribeForm":"SubscribeForm_subscribeForm__iZObQ","error":"SubscribeForm_error__6x9VE","notification":"SubscribeForm_notification__0eAn3","info":"SubscribeForm_info__fCGwQ"};